:host(.context-menu-icon) {
  --height: 22px;
  --width: 22px;
  --font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size);
  height: var(--height);
  width: var(--width);

  img {
    width: 14px;
    height: 14px;
  }
}
